import React, { useMemo } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import Cargando from 'components/Varios/Cargando'
import ButtonAceptar from 'components/Varios/Modals/ButtonAceptar'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'



type PropsModalVerDocumentoPDF = {
    show: boolean,
    urlArchivo: string,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    cargandoDatos: boolean,
    tituloModal: string,
    botonCerrar?: boolean,
    nombreBotonAccion?: string
    allHeight?:boolean
}

export default function ModalVistaPreviaDocumentos(props: PropsModalVerDocumentoPDF) {

    const allHeight = props.allHeight !== undefined && props.allHeight === true;

    function CerrarModal() {
        props.onClose();
        document.body.classList.remove('modal-open')
    }

    const ContenidoModalBody = useMemo(() => {
        if (props.cargandoDatos) {
            return (
                <Cargando />
            )
        }
        else if (!props.cargandoDatos && props.urlArchivo !== "") {


            

            if(allHeight){
                return (
                    <div style={{ overflowX: "auto", height:"100%" }} className="row text-center mb-3">
                        <object data={props.urlArchivo}
                            type="application/pdf"
                            width="100%"
                            height={"100%"}
    
                        >
                        </object>
                    </div>
                )
            }
            else{
                return (
                    <div className="containerPdfCertificadoVP" >
                        <object data={props.urlArchivo + "#zoom=90"}
                            type="application/pdf"
                            className={"container-pdf"}
                        >
                        </object>
                    </div>
                )
            }

       
        }
        else {
            return (
                <div>
                    No hay contenido por mostrar
                </div>
            )
        }
    }, [props.urlArchivo, props.cargandoDatos])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => CerrarModal()}
            />
        )
    }
        , [props])


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => CerrarModal()}
        // contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>

            <ModalBody className={`${allHeight ? "allHeight" :"modbodyVPDocumentos"}`}>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>
                {props.botonCerrar !== undefined && props.botonCerrar === true &&
                    <ButtonAceptar
                        handleClickAceptar={() => CerrarModal()}
                        nombreBoton={"Cerrar"}
                    />
                }
                <ButtonAceptar
                    handleClickAceptar={() => CerrarModal()}
                    nombreBoton={props.nombreBotonAccion}
                />

            </ModalFooter>
        </Modal>

    )



}
